module.exports = __webpack_public_path__ + "img/btn_sound-off.d224effc.png";